import { Ban } from 'lucide-react';

export function AuditorRevokedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base px-4">
      <div className="w-full max-w-md text-center">
        <Ban className="mx-auto mb-4 h-12 w-12 text-red-400" />
        <h1 className="mb-2 text-2xl font-bold text-text-primary">Access Revoked</h1>
        <p className="text-text-secondary">
          Your auditor access has been revoked by the organisation.
          If you believe this was done in error, contact the organisation directly.
        </p>
      </div>
    </div>
  );
}
